<app-nav-header></app-nav-header>
<app-sidebar-menu></app-sidebar-menu>

<div class="page-content-wrapper">
  <div class="page-content">
    <div class="page-bar">
      <div class="page-title-breadcrumb">
        <div class="container">
          <div class="row">
            <div class="col-md-10">
              <div class="page-title">Valor de Corrida</div>
            </div>
            <div class="col-md-2">
              <a type="button" routerLink="/parameters/request-value/new"
                class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-primary">Adicionar
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <ngx-loading [show]="loading"> </ngx-loading>
      </div>
      <div class="container"></div>
      <div class="row">
        <div class="col-md-12">
          <div class="card card-topline-green">
            <div class="card-head">
              <div class="col-md-4 position-right" [formGroup]="showResultsForm">
                <select (change)="onSelected($event)" formControlName="per_page" class="custom-select custom-select-sm">
                  <option value="10">Mostrar 10 Resultados</option>
                  <option value="20">Mostrar 20 Resultados</option>
                  <option value="30">Mostrar 30 Resultados</option>
                  <option value="{{ pagination.totalResults }}">
                    Mostrar Todos os Resultados
                  </option>
                </select>
              </div>
              <header>
                <div class="row" [formGroup]="searchForm">
                  <div class="col">
                    <input type="text" class="form-control" placeholder="Destino" formControlName="destiny" />
                  </div>
                  <div class="col">
                    <input type="text" class="form-control" placeholder="Hora Início" formControlName="initialHour" />
                  </div>
                  <div class="col">
                    <input type="text" class="form-control" placeholder="Hora fim" formControlName="endHour" />
                  </div>
                  <div class="col">
                    <select formControlName="type" class="form-control">
                      <option value="null">Tipo</option>
                      <option value="covenant">Convênio</option>
                      <option value="client">Cliente</option>
                    </select>
                  </div>
                  <div class="col">
                    <select formControlName="active" class="form-control">
                      <option value="null">Status</option>
                      <option value="true">Ativo</option>
                      <option value="false">Inativo</option>
                    </select>
                  </div>
                  <div class="col">
                    <a (click)="onSearch()" class="btn btn-info">
                      <i class="fa fa-search"></i>
                    </a>
                  </div>
                </div>
              </header>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-striped custom-table table-hover">
                  <thead>
                    <tr>
                      <!-- <th>Código</th> -->
                      <th>Tipo</th>
                      <th>Destino</th>
                      <th>Valor</th>
                      <th>Valor Hora Adicional</th>
                      <th>Comissão do motorista</th>
                      <th>Status</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let requestValue of requestValues">
                      <!-- <td>{{ requestValue.id }}</td> -->
                      <td>{{ requestValue.type }}</td>
                      <td>
                        {{ requestValue.destiny }}
                      </td>
                      <td>
                        {{ requestValue.value | currency: "BRL" }}
                      </td>
                      <td>
                        {{ requestValue.aditionalValue | currency: "BRL" }}
                      </td>
                      <td>
                        {{ requestValue.percentage | percent }}
                      </td>
                      <td>
                        <span *ngIf="requestValue.active" class="label label-sucess label-mini">Ativo</span>
                        <span *ngIf="!requestValue.active" class="label label-danger label-mini">Inativo</span>
                      </td>
                      <td>
                        <a routerLink="/parameters/request-value/view/{{ requestValue.id }}" class="btn btn-primary btn-xs">
                          <i class="fa fa-eye"></i>
                        </a>
                        <a routerLink="/parameters/request-value/edit/{{ requestValue.id }}" class="btn btn-warning btn-xs">
                          <i class="fa fa-pencil"></i>
                        </a>

                        <!-- <button (click)="onDelete(requestValue)" class="btn btn-danger btn-xs">
                                                    <i class="fa fa-trash-o "></i>
                                                </button> -->
                        <span *ngIf="requestValue.active">
                          <button (click)="onDeActive(requestValue)" class="btn btn-pink btn-xs">
                            <i class="fa fa-random"></i>
                          </button>
                        </span>
                        <span *ngIf="!requestValue.active">
                          <button (click)="onActive(requestValue)" class="btn btn-success btn-xs">
                            <i class="fa fa-random"></i>
                          </button>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="row">
                  <div class="col-md-12">
                    <span *ngIf="!requestValues.length" class="label label-danger label-mini">Nenhum Valor das corridas
                      encontrado.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <nav aria-label="Page navigation example">
            <ul class="pagination justify-content-center">
              <li class="page-item" [class.disabled]="!first">
                <button class="page-link" (click)="onFirst()" tabindex="-1">
                  Primeira
                </button>
              </li>
              <li class="page-item" *ngIf="pagination.page != 1">
                <button (click)="onPrevious()" class="page-link">
                  {{ pagination.page - 1 }}
                </button>
              </li>
              <li class="page-item active">
                <button class="page-link">{{ pagination.page }}</button>
              </li>
              <li class="page-item" *ngIf="last">
                <button (click)="onNext()" class="page-link" href="#">
                  {{ pagination.page + 1 }}
                </button>
              </li>
              <li class="page-item" [class.disabled]="!last">
                <button class="page-link" (click)="onLast()">Última</button>
              </li>
            </ul>
          </nav>
        </div>
        <div class="col-md-12">
          Mostrando página {{ pagination.page }} de
          {{ pagination.totalPages }} dos
          {{ pagination.totalResults }} Resultados
        </div>
      </div>
    </div>
  </div>
</div>
